import { render, staticRenderFns } from "./card.vue?vue&type=template&id=a9127a1a&scoped=true&"
import script from "./card.vue?vue&type=script&lang=js&"
export * from "./card.vue?vue&type=script&lang=js&"
import style0 from "./card.vue?vue&type=style&index=0&id=a9127a1a&lang=scss&scoped=true&"
import style1 from "./card.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9127a1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9127a1a')) {
      api.createRecord('a9127a1a', component.options)
    } else {
      api.reload('a9127a1a', component.options)
    }
    module.hot.accept("./card.vue?vue&type=template&id=a9127a1a&scoped=true&", function () {
      api.rerender('a9127a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/my/card.vue"
export default component.exports